import type { FC } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import AdminPage from "../pages/AdminPage";
import BrandPage from "../pages/BrandPage";
import CompanyPage from "../pages/CompanyPage";
import DistributorPage from "../pages/DistributorPage";
import HomePage from "../pages/HomePage";
import MasterProductDetailPage from "../pages/MasterProductDetailPage";
import MasterProductPage from "../pages/MasterProductPage";
import MerchantDetail from "../pages/MerchantDetail";
import MerchantPage from "../pages/MerchantPage";
import NotFound from "../pages/NotFound";
import PopularProductPage from "../pages/PopularProductPage";
import PriceCategoryPage from "../pages/PriceCategoryPage";
import ProductAttributePage from "../pages/ProductAttributePage";
import ProductCategoryPage from "../pages/ProductCategoryPage";
import ProductDetailPage from "../pages/ProductDetailPage";
import ProductPage from "../pages/ProductPage";
import ProductRecommendationPage from "../pages/ProductRecommendation";
import RolePage from "../pages/RolePage";
import SettingPage from "../pages/SettingPage";
import StockMovementPage from "../pages/StockMovementPage";
import TopBrandPage from "../pages/TopBrandPage";
import UserPage from "../pages/UserPage";
import WarehousePage from "../pages/WarehousePage";
import TagPage from "../pages/TagPage";
import SalesPage from "../pages/SalesPage";
import SalesDetail from "../pages/SalesDetail";
import MerchantTypePage from "../pages/MerchantTypePage";
import ProductPendingPage from "../pages/ProductPendingPage";
import WithdrawalPage from "../pages/WithdrawalPage";
import WithdrawalDetail from "../pages/WithdrawalDetail";
import BannerPage from "../pages/BannerPage";
import PromotionPage from "../pages/PromotionPage";
import PromotionDetail from "../pages/PromotionDetail";

interface PrivateRoutesProps {}

const PrivateRoutes: FC<PrivateRoutesProps> = ({}) => {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/brand" element={<BrandPage />} />
      <Route path="/top-brand" element={<TopBrandPage />} />
      <Route path="/tag" element={<TagPage />} />
      <Route path="/popular-product" element={<PopularProductPage />} />
      <Route path="/company" element={<CompanyPage />} />
      <Route path="/distributor" element={<DistributorPage />} />
      <Route path="/master-product" element={<MasterProductPage />} />
      <Route path="/master-product/:masterProductId" element={<MasterProductDetailPage/>} />
      <Route path="/product-recommendation" element={<ProductRecommendationPage />} />
      <Route path="/product" element={<ProductPage />} />
      <Route path="/product-pending" element={<ProductPendingPage />} />
      <Route path="/product/:productId" element={<ProductDetailPage />} />
      <Route path="/product-category" element={<ProductCategoryPage />} />
      <Route path="/product-attribute" element={<ProductAttributePage />} />
      <Route path="/price-category" element={<PriceCategoryPage />} />
      <Route path="/warehouse" element={<WarehousePage />} />
      <Route path="/stock-movement" element={<StockMovementPage />} />
      <Route path="/merchant" element={<MerchantPage />} />
      <Route path="/merchant-type" element={<MerchantTypePage />} />
      <Route path="/merchant/:merchantId" element={<MerchantDetail />} />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="/user" element={<UserPage />} />
      <Route path="/role" element={<RolePage />} />
      <Route path="/setting" element={<SettingPage />} />
      <Route path="/sales" element={<SalesPage />} />
      <Route path="/banner" element={<BannerPage />} />
      <Route path="/promotion" element={<PromotionPage />} />
      <Route path="/promotion/:promotionId" element={<PromotionDetail />} />
      <Route path="/withdrawal" element={<WithdrawalPage />} />
      <Route path="/withdrawal/:withdrawalId" element={<WithdrawalDetail />} />
      <Route path="/sales/:salesId" element={<SalesDetail />} />
      <Route path="/login" element={<Navigate to="/" replace />} />
      <Route path="*" element={<NotFound />} />
      
    </Routes>
  );
};
export default PrivateRoutes;
